export default __webpack_public_path__ + "static/media/checked-circle-outlined-green.54b9a2cb.svg";